export default __webpack_public_path__ + "static/media/built-on-sure.df0c9af3.svg";